import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

interface ChipButtonProps extends Omit<ButtonProps, 'style' | 'type'> {
  children: React.ReactNode;
}

export const ChipButton: React.FC<ChipButtonProps> = ({ children, ...props }) => {
  const { fontSize, spacing } = useResponsiveSizes();
  return (
    <Button
      {...props}
      type='default'
      style={{
        backgroundColor: '#f5f5f5',
        borderColor: '#d9d9d9',
        color: '#595959',
        height: 'auto',
        padding: `${spacing.xs}px ${spacing.sm}px`,
        transition: 'all 0.2s ease',
        userSelect: 'none',
        fontSize: fontSize.sm
      }}
      onMouseEnter={e => {
        const target = e.currentTarget as HTMLElement;
        target.style.backgroundColor = '#f0f0f0';
        target.style.borderColor = '#bfbfbf';
        target.style.transform = 'translateY(-1px)';
        target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
      }}
      onMouseLeave={e => {
        const target = e.currentTarget as HTMLElement;
        target.style.backgroundColor = '#f5f5f5';
        target.style.borderColor = '#d9d9d9';
        target.style.transform = 'translateY(0)';
        target.style.boxShadow = 'none';
      }}
    >
      {children}
    </Button>
  );
};
